module.exports = __webpack_public_path__ + "static/img/clickin52.5be0fa01.png";